"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var react_1 = require("@emotion/react");
var houston_tokens_1 = require("@eduzz/houston-tokens");
var App_1 = require("./App");
var context_1 = require("./context");
function Main(_a) {
    var _b;
    var _c = _a.application, application = _c === void 0 ? 'eduzz' : _c, userName = _a.userName, eduzzId = _a.eduzzId, _d = _a.action, action = _d === void 0 ? 'newTab' : _d, _e = _a.env, env = _e === void 0 ? ((_b = process.env) === null || _b === void 0 ? void 0 : _b.REACT_APP_ENV) || 'production' : _e, returnTo = _a.returnTo, className = _a.className;
    var theme = React.useMemo(function () { return (0, houston_tokens_1.default)(application); }, [application]);
    React.useEffect(function () {
        if (action === 'newTab')
            return;
        function messageHandler(event) {
            if (event.data.action === 'saveFidcAuthToken') {
                localStorage.setItem(event.data.key, event.data.value);
            }
        }
        window.addEventListener('message', messageHandler);
        return function () {
            window.removeEventListener('message', messageHandler);
        };
    }, [action]);
    React.useEffect(function () {
        if (action === 'newTab')
            return;
        var fidcAuthToken = localStorage.getItem('fidc-auth-token');
        if (fidcAuthToken) {
            window.postMessage({
                action: 'setFidcAuthToken',
                value: fidcAuthToken
            }, '*');
        }
    }, [action]);
    React.useEffect(function () {
        var styleElement = document.createElement('link');
        styleElement.rel = 'stylesheet';
        styleElement.href = '//fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700';
        document.head.appendChild(styleElement);
        return function () { return styleElement.remove(); };
    }, []);
    return ((0, jsx_runtime_1.jsx)(React.Suspense, __assign({ fallback: null }, { children: (0, jsx_runtime_1.jsx)(react_1.ThemeProvider, __assign({ theme: theme }, { children: (0, jsx_runtime_1.jsx)(context_1.ContextProvider, __assign({ application: application, userName: userName, eduzzId: eduzzId, action: action, env: env, returnTo: returnTo }, { children: (0, jsx_runtime_1.jsx)(App_1.App, { className: className }) })) })) })));
}
exports.default = Main;
